"use client";

import { useState, useEffect } from "react";
import { WifiOff } from "lucide-react";
import { useTranslations } from "next-intl";

export default function PWAOfflineIndicator() {
  const t = useTranslations("PWA");
  const [isOffline, setIsOffline] = useState(false);

  useEffect(() => {
    // Delay initial detection slightly to avoid false offline flashes during boot.
    const bootTimer = window.setTimeout(() => {
      setIsOffline(!navigator.onLine);
    }, 400);

    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.clearTimeout(bootTimer);
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[10000] flex items-center justify-center gap-2 bg-[var(--apple-red)] px-4 py-2 text-xs font-medium text-white safe-top">
      <WifiOff className="h-3.5 w-3.5" />
      <span>{t("offline_bar")}</span>
    </div>
  );
}
